export default __webpack_public_path__ + "static/media/microcentrifuge_lid_close.fbcf15e6.svg";